const DICEBEAR_BASE = "https://api.dicebear.com/9.x/thumbs/svg";

/**
 * Return the best avatar URL for a user.
 * Priority: custom avatarUrl > DiceBear generated avatar.
 */
export function getAvatarUrl(
  avatarUrl: string | null | undefined,
  userId: string,
): string {
  if (avatarUrl) return avatarUrl;
  return getDiceBearUrl(userId);
}

/** Generate a deterministic DiceBear "thumbs" avatar URL from a seed. */
export function getDiceBearUrl(seed: string): string {
  return `${DICEBEAR_BASE}?seed=${encodeURIComponent(seed)}`;
}
